export default __webpack_public_path__ + "static/media/Custom Software Icon.c2d29ed8.svg";